export const isBrowser = (): boolean => typeof window !== 'undefined'

export const windowNavigatorExists = (): boolean =>
	window !== undefined && window.navigator !== undefined
